import React from 'react';
import { motion } from 'framer-motion';
export function TrustBar() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    delay: 0.5
  }} className="w-full bg-carbon border-b border-dark-border py-4 px-4 overflow-hidden" data-id="element-366">
      <div className="max-w-5xl mx-auto flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-xs md:text-sm text-gray-sec font-medium tracking-wide" data-id="element-367">
        <span className="flex items-center gap-2" data-id="element-368">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-369"></span>
          +200 Empresas de Roofing Confían en Nosotros
        </span>
        <span className="hidden md:inline text-dark-border" data-id="element-370">|</span>
        <span className="flex items-center gap-2" data-id="element-371">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-372"></span>
          Sistema Probado en 15 Ciudades
        </span>
        <span className="hidden md:inline text-dark-border" data-id="element-373">|</span>
        <span className="flex items-center gap-2" data-id="element-374">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-375"></span>
          $2M+ en Contratos Generados
        </span>
      </div>
    </motion.div>;
}